import React, { useState } from "react";
import "./Hospitality.css";

export default function Event() {
  const [activeIndex, setActiveIndex] = useState(0);

  const hospitalityData = [
    {
      title: "The Retreat Darjeeling",
      heading: "The Retreat Darjeeling",
      desc: `With the sublime view of Kanchenjunga from the window, this boutique hotel offers quiet luxury alongside the majesty of nature in its purest form. ​`,
      link: "https://theretreatdarjeeling.com/",
      bg: "/images/hospitality/default.png",
    },
    {
      title: "Cafe House",
      heading: "Cafe House",
      desc: `Have absolutely gourmet food, while cherishing the raw beauty of Kanchenjunga in solitude.​`,
      link: "#",
      bg: "/images/hospitality/coffee_house.jpg",
    },
    {
      title: "Aroma",
      heading: "Aroma",
      desc: `Premium dining experience, dipped in elegance and authenticity, with Kanchenjunga at
your side. ​`,
      link: "#",
      bg: "/images/hospitality/aroma.jpg",
    },
  ];

  return (
    <>
<div className="hospitality">
      <div className="container-custom">

        {/* Top Banner */}
        <div className="media-top">
          <h2>Hospitality</h2>

          <a href="/hospitality" className="learn-more">
            <i className="bi bi-arrow-right-circle-fill"></i>
            Learn more
          </a>
        </div>

        {/* Hospitality Panels */}
        <div className="hospitality">
          <div className="containerr">

            {hospitalityData.map((item, index) => (
              <div
                key={index}
                className={`item-link ${activeIndex === index ? "active" : ""
                  }`}
                style={{ backgroundImage: `url(${item.bg})` }}
                onClick={() => setActiveIndex(index)}
              >
                {/* Sidebar Label */}
                <div className={`sidebar-form sidebar-${index}`}>
                  {item.title}
                </div>

                {/* Content */}
                <div className="item-contain">
                  <div className="item-contain-des">
                    <div className="banner">

                      <div className="left-box">
                        <h2>

                          {item.heading}

                        </h2>
                      </div>

                      <div className="right-box">
                        <p>{item.desc}</p>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            ))}

          </div>
        </div>
      </div>
</div>
    </>
  );
}
